import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { EsnAppeloffreService } from './../../../../core/services/esn-appeloffre/esn-appeloffre.service';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { environment } from './../../../../../environment/environment';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
const DOMPurify = require('dompurify')

@Component({
  selector: 'app-details-offer',
  templateUrl: './details-offer.component.html',
  styleUrls: ['./details-offer.component.css'],
})
export class DetailsOfferComponent {
  /* number */
  tabulation: number = 10;
  /* boolean */
  disabledMode: boolean = true;
  /* object */
  jobofferDetails: any;
  /* string */
  idEsn!: string;
  nameEsn = this.localStorageService.getData('clientConnectedName');

  idclientConnected = this.localStorageService.getData('clientConnected');
  skills: any;
  /* formGroup */
  /* unsubscription */
  id = this.activatedRoute.snapshot.params['id'];
  state = this.activatedRoute.snapshot.params['state'];
  applyForm: FormGroup = this.createForm();
  colorsHeader: string[] = [
    '#FBF2E9',
    '#E8F6FC',
    '#FDEFEE',
    '#FFF3D7',
    '#FBF2E9',
  ];
  iduser: any;
  private unsubscribeAll: Subject<void> = new Subject();
  listconsultant: any;
  urlimage: string = environment.baseUrlGalery;
  /* string */
  url: string = environment.baseUrl + '/api';
  selectedUserId!: string;
  safeDescription!: SafeHtml;
  disponibilite = [
    { id: 1, name: 'Immédiate' },
    { id: 3, name: '2 mois' },
    { id: 4, name: '3 mois' },
    { id: 5, name: '4 mois' },
    { id: 6, name: '5 mois' },
  ];
  currentUser: any;
  company_id: any;
  companyRoleId: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private appelofferservice: EsnAppeloffreService,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService,
    private formBuilder: FormBuilder,
    private localStorageService: LocalStorageService,
    private sanitizer: DomSanitizer
  ) {}
  ngOnInit() {
    window.scrollTo(0, 0);
    console.log('bienvenu!!');
    console.log('is state', this.state);
    this.getjobofferById();
    this.getskillsjobrequest();
    this.getlistconsultant();
    this.getcurrentUser();
  }
  getcurrentUser() {
    this.currentUser = this.localStorageService.getData('UserInfo');
    this.companyRoleId = JSON.parse(this.currentUser).role_user_id;
    console.log(
      'companyRoleId',
      this.companyRoleId,
      this.companyRoleId.includes('8')
    );
  }
  

  isEsnNotSubscribed(): boolean {
    return !this.companyRoleId.includes('8');
  }
  isEsnSubscribed(): boolean {
    return this.companyRoleId.includes('7');
  }

  /* get job offer details */
  getjobofferById() {
    this.spinner.show();
    this.appelofferservice.getappeloffreById(this.id).subscribe({
      next: (res: any) => {
        console.log('job', this.jobofferDetails);
        this.spinner.hide();

        this.jobofferDetails = res.data[0];
        this.updateDescription(this.jobofferDetails.description);
        console.log('detail job offer', this.jobofferDetails);
      },
      error: (error) => {
        console.log('error', error);
        this.spinner.hide();
      },
    });
  }
  updateDescription(description: string) {
    const sanitizedHtml = DOMPurify.sanitize(description);
    this.safeDescription = this.sanitizer.bypassSecurityTrustHtml(sanitizedHtml);
  }

  /* get skills job request  */
  getskillsjobrequest() {
    this.appelofferservice.getskillsappeloffre(this.id).subscribe({
      next: (res: any) => {
        this.skills = res.data;
        console.log('skills job request', this.skills);
      },
      error: (error) => {
        console.log('error', error);
      },
    });
  }

  getlistconsultant() {
    console.log('nameEsn', this.nameEsn);
    this.appelofferservice.getlistconsultantbyoffre(this.nameEsn).subscribe({
      next: (res: any) => {
        this.listconsultant = res.data;
        this.listresponsablesWithDisplayName();
        console.log('list consultant by offre', this.listconsultant);
      },
      error: (error) => {
        console.log(error);
      },
    });
  }
  listresponsablesWithDisplayName() {
    this.listconsultant.map((el: any) => {
      el.name = `${el.first_name} ${el.last_name}`;
    });
    console.log('membres2', this.listconsultant);
  }
  // getconsultantid(e: any) {
  //   if (e.target.checked) {
  //     console.log("Selected user id:", this.selectedUserId);
  //   } else {

  //     console.log("Checkbox unchecked");
  //   }
  // }

  getconsultantid(e: any, userId: string) {
    if (e.target.checked) {
      this.selectedUserId = userId;
      console.log('Selected user id:', this.selectedUserId);

      // Décocher toutes les autres cases sauf celle qui a été cochée
      this.deselectOtherCheckboxes(userId);
    } else {
      // La case est décochée, vous pouvez ajouter un code supplémentaire si nécessaire
      console.log('Checkbox unchecked');
    }
  }

  deselectOtherCheckboxes(currentUserId: string) {
    // Parcourir la liste des consultants et décocher les cases sauf celle qui a été cochée
    // Assurez-vous que this.consultants est la liste de vos consultants
    this.listconsultant.forEach((consultant: any) => {
      if (consultant.id !== currentUserId) {
        consultant.checked = false; // Ajoutez une propriété "checked" à votre objet consultant si elle n'existe pas
      }
    });
  }
  pastDateValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const date = control.value;
      if (date) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Ignorer les heures pour comparer uniquement les dates
        const inputDate = new Date(date);

        if (inputDate < today) {
          return { pastDate: true };
        }
      }
      return null;
    };
  }
  createForm(data?: any) {
    return this.formBuilder.group({
      commercial_argument: [data ? data.commercial_argument : ''],
      tjm_vente: [data ? data.tjm_vente : ''],
      availibility_date: [
        data ? data.availibility_date : '',
        [this.pastDateValidator()],
      ],
      user_id: [data ? data.user_id : null, [Validators.required]],
    });
  }
  applyJob() {
    let data = {
      company_id: this.idclientConnected,
      user_id: this.selectedUserId,
      job_request_id: this.id,
    };
    console.log('data', data);
    this.appelofferservice
      .applyJob({ ...data, ...this.applyForm.value })
      .subscribe({
        next: (res: any) => {
          console.log('res', res);
          this.applyForm.reset();
          this.toastrService.success(
            'votre candidature a été envoyé avec succès.'
          );
        },
        error: (error) => {
          this.applyForm.reset();
          console.log(error.error.message);
          if (error.error.message === 'candidature already exist.') {
            this.toastrService.error(
              'Vous avez déjà postulé à cet appel offre'
            );
          }
          if (error.error.message === 'the job offer has been deactivated.') {
            this.toastrService.error(
              "La postulation n'est pas autorisée car l'appel d'offres est désactivé."
            );
          }
        },
      });
  }
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
}
